<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="media">
              <div class="mr-3">
                <img
                  :src="urlImage + user_profile.avatar"
                  class="avatar-md rounded-circle img-thumbnail"
                  alt="avatar"
                  v-if="user_profile.avatar"
                />

                <img
                  src="@/assets/images/users/avatar-10.jpg"
                  class="avatar-md rounded-circle img-thumbnail"
                  alt="avatar"
                  v-else
                />
              </div>
              <div class="media-body align-self-center">
                <div class="row">
                  <div class="col-4">
                    <div class="text-muted">
                      <h5>{{ user_profile.name }}</h5>
                      <p class="mb-1">{{ user_profile.email }}</p>
                      <p class="mb-0">
                        Role :
                        <span
                          class="
                            badge badge-secondary
                            p-1
                            px-2
                            badge-md
                            rounded
                          "
                          variant="secondary"
                          v-if="user_profile.role == 'admn'"
                        >
                          Admin</span
                        >
                        <span
                          class="badge badge-info p-1 px-2 rounded"
                          v-else-if="user_profile.role == 'anly'"
                        >
                          {{ $t("dashboards.analyst") }}</span
                        >
                        <span
                          class="badge badge-success p-1 px-2 rounded"
                          v-else-if="user_profile.role == 'verf'"
                        >
                          {{ $t("dashboards.verifier") }}</span
                        >
                      </p>
                    </div>
                  </div>
                  <div class="col-3 text-center">
                    <h5 class="text-success">Total {{ $t("dashboards.report") }}</h5>
                    <h2>{{ total_report }}</h2>
                  </div>
                  <div class="col-3 text-center">
                    <h5 class="text-success">Total {{ $t("dashboards.verification") }}</h5>
                    <h2>{{ total_validation }}</h2>
                  </div>
                </div>
              </div>
              <b-dropdown
                v-if="rl == 'admn'"
                ngbDropdown
                menu-class="dropdown-menu-md"
                right
                variant="light"
              >
                <template v-slot:button-content>
                  <i class="fa fa-cog mr-2"></i>
                  <span class="d-none d-sm-inline-block" ngbDropdownToggle>
                    {{ $t("malware.setting") }}
                    <i class="mdi mdi-chevron-down"></i>
                  </span>
                </template>

                <div class="dropdown-item-text">
                  <div>
                    <p class="text-muted mb-2">On development</p>
                    <h5 class="mb-0">-</h5>
                  </div>
                </div>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item>
                  <span class="btn-block" @click="openChangePassword"
                    >Reset Password</span
                  >
                  <span class="float-right"></span>
                </b-dropdown-item>
                <!-- <b-dropdown-item>
                  Blokir
                  <span class="float-right"></span>
                </b-dropdown-item> -->
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-6">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title mb-4">
              {{ $t("malware.personal-information") }}
            </h4>
            <div class="table-responsive mb-0" v-if="rl == 'admn'">
              <table class="table">
                <tbody>
                  <tr>
                    <th scope="row">{{ $t("user-management.name") }}</th>
                    <td>{{ user_profile.name }}</td>
                  </tr>
                  <tr>
                    <th scope="row">{{ $t("user-management.username") }}</th>
                    <td>{{ user_profile.username }}</td>
                  </tr>
                  <tr>
                    <th scope="row">{{ $t("user-management.email") }}</th>
                    <td>{{ user_profile.email }}</td>
                  </tr>
                  <tr>
                    <th scope="row">{{ $t("user-management.role") }}</th>
                    <td>
                      <span
                        class="badge badge-secondary p-1 px-1 badge-md rounded"
                        variant="secondary"
                        v-if="user_profile.role == 'admn'"
                      >
                        Admin</span
                      >
                      <span
                        class="badge badge-info p-1 px-1 rounded"
                        v-else-if="user_profile.role == 'anly'"
                      >
                        {{ $t("dashboards.analyst") }}</span
                      >
                      <span
                        class="badge badge-success p-1 px-1 rounded"
                        v-else-if="user_profile.role == 'verf'"
                      >
                        {{ $t("dashboards.verifier") }}</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">{{ $t("user-management.last_login") }}</th>
                    <td>{{ user_profile.last_login }}</td>
                  </tr>
                  <tr>
                    <th scope="row">{{ $t("table.created_at") }}</th>
                    <td>{{ user_profile.created_at }}</td>
                  </tr>
                  <tr>
                    <th scope="row">{{ $t("table.updated_at") }}</th>
                    <td>{{ user_profile.updated_at }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="table-responsive mb-0" v-else>
              <table class="table">
                <tbody>
                  <tr>
                    <th scope="row">{{ $t("user-management.name") }}</th>
                    <td>{{ user_profile.name }}</td>
                  </tr>
                  <tr>
                    <th scope="row">{{ $t("user-management.email") }}</th>
                    <td>{{ user_profile.email }}</td>
                  </tr>
                  <tr>
                    <th scope="row">{{ $t("user-management.role") }}</th>
                    <td>
                      <span
                        class="badge badge-secondary p-1 px-1 badge-md rounded"
                        variant="secondary"
                        v-if="user_profile.role == 'admn'"
                      >
                        Admin</span
                      >
                      <span
                        class="badge badge-info p-1 px-1 rounded"
                        v-else-if="user_profile.role == 'anly'"
                      >
                        {{ $t("dashboards.analyst") }}</span
                      >
                      <span
                        class="badge badge-success p-1 px-1 rounded"
                        v-else-if="user_profile.role == 'verf'"
                      >
                        {{ $t("dashboards.verifier") }}</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">{{ $t("user-management.last_login") }}</th>
                    <td>{{ user_profile.last_login }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="card h-100">
          <div
            class="rounded"
            :class="theme == 'light' ? 'bg-white' : 'border-info'"
          >
            <div class="card-body">
              <h4 class="card-title mb-4">
                {{ $t("malware.status-report") }}
              </h4>
              <div
                v-if="
                  user_profile.role == 'admn' || user_profile.role == 'anly'
                "
              >
                <apexchart
                  class="apex-charts"
                  dir="ltr"
                  height="360"
                  :series="[
                    status_report.draft,
                    status_report.pending,
                    status_report.not_valid,
                    status_report.valid,
                  ]"
                  :options="statusReport.chartOptions"
                ></apexchart>
              </div>
              <div v-else>
                <span>-</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-if="!loading && tableData[0]">
            <h5>{{ $t("malware.history-report") }}</h5>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("table.show_label") }}&nbsp;&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      class="mx-1"
                    ></b-form-select
                    >&nbsp;&nbsp;{{ $t("table.entri_label") }}
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("table.search_label") }}:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      :placeholder="$t('navbar.search.text')"
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                responsive="sm"
                striped
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(username)="row">
                  <!-- {{row.item.avatar }} -->
                  <!-- <img
                      src="@/assets/images/users/avatar-10.jpg"
                      class="mr-3 rounded-circle avatar-xs"
                      alt="user-pic"
                    /> -->
                  <img
                    :src="urlImage + row.item.avatar"
                    class="rounded-circle header-profile-user"
                    alt="avatar"
                    v-if="row.item.avatar"
                  />
                  <img
                    src="@/assets/images/users/avatar-10.jpg"
                    class="rounded-circle header-profile-user"
                    alt="avatar"
                    v-else
                  />
                  {{ row.item.username }}
                </template>
                <template #cell(description)="row">
                  <span v-if="row.item.description"
                    >{{ row.item.description.substring(0, 80) }}
                  </span>
                  <span v-if="row.item.description.length > 80">..</span>
                </template>
                <template #cell(status_report)="row">
                  <span
                    v-if="row.item.status_report === '3'"
                    class="badge badge-success rounded"
                    >Valid</span
                  >
                  <span
                    v-if="row.item.status_report === '2'"
                    class="badge badge-danger rounded"
                    >Not Valid</span
                  >
                  <span
                    v-if="row.item.status_report === '1'"
                    class="badge badge-info rounded"
                    >Pending</span
                  >
                  <span
                    v-if="row.item.status_report === '0'"
                    class="badge badge-warning rounded"
                    >Draft</span
                  >
                </template>
                <template #cell(created_at)="row">
                  <span>{{ formatDate(row.item.created_at) }}</span>
                </template>
                <template #cell(actions)="row">
                  <router-link
                    :to="{
                      path: '/malware/detail-report',
                      query: { id: getId(row.item.id_report) },
                    }"
                  >
                    <b-button class="mr-1" variant="success" size="sm">{{
                      $t("malware.view-details")
                    }}</b-button>
                  </router-link>
                </template>
              </b-table>
            </div>
            <div class="row" v-if="rows > 10">
              <div class="col-2">
                <!-- <div v-if="selected[0]">
                        <b-button class="btn btn-sm" variant="danger" @click="bulkAction()">Bulk Delete : {{selected.length}} Rows Data</b-button>
                      </div> -->
                <label class="d-inline-flex align-items-center">
                  Page
                  <b-form-input
                    v-model="currentPage"
                    placeholder="Page"
                    class="form-control w-10 form-control ml-2"
                  ></b-form-input>
                </label>
              </div>
              <div class="col-10 text-right" v-if="rows > 10">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body" v-if="loading && !tableData[0]">
            <div class="row">
              <div class="col-12 text-center align-item-center m-5 p-5">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div>
                  <span>Loading..</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-if="!loading && tableDataVerification[0]">
            <h5>{{ $t("malware.history-verification") }}</h5>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("table.show_label") }}&nbsp;&nbsp;
                    <b-form-select
                      v-model="perPageVerif"
                      size="sm"
                      :options="pageOptionsVerif"
                      class="mx-1"
                    ></b-form-select
                    >&nbsp;&nbsp;{{ $t("table.entri_label") }}
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("table.search_label") }}:
                    <b-form-input
                      v-model="filterVerif"
                      type="search"
                      :placeholder="$t('navbar.search.text')"
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableDataVerification"
                :fields="fields"
                responsive="sm"
                striped
                :per-page="perPageVerif"
                :current-page="currentPageVerif"
                :sort-desc.sync="sortDescVerif"
                :filter="filterVerif"
                :filter-included-fields="filterOnVerif"
                @filtered="onFilteredVerif"
              >
                <template #cell(username)="row">
                  <img
                    :src="urlImage + row.item.avatar"
                    class="rounded-circle header-profile-user"
                    alt="avatar"
                    v-if="row.item.avatar"
                  />
                  <img
                    src="@/assets/images/users/avatar-10.jpg"
                    class="rounded-circle header-profile-user"
                    alt="avatar"
                    v-else
                  />
                  {{ row.item.username }}
                </template>
                <template #cell(description)="row">
                  <span v-if="row.item.description"
                    >{{ row.item.description.substring(0, 80) }}
                  </span>
                  <span v-if="row.item.description.length > 80">..</span>
                </template>
                <template #cell(status_report)="row">
                  <span
                    v-if="row.item.status_report === '3'"
                    class="badge badge-success rounded"
                    >Valid</span
                  >
                  <span
                    v-if="row.item.status_report === '2'"
                    class="badge badge-danger rounded"
                    >Not Valid</span
                  >
                  <span
                    v-if="row.item.status_report === '1'"
                    class="badge badge-info rounded"
                    >Pending</span
                  >
                  <span
                    v-if="row.item.status_report === '0'"
                    class="badge badge-warning rounded"
                    >Draft</span
                  >
                </template>
                <template #cell(created_at)="row">
                  <span>{{ formatDate(row.item.created_at) }}</span>
                </template>
                <template #cell(actions)="row">
                  <router-link
                    :to="{
                      path: '/malware/detail-report',
                      query: { id: getId(row.item.id_report) },
                    }"
                  >
                    <b-button class="mr-1" variant="success" size="sm">{{
                      $t("malware.view-details")
                    }}</b-button>
                  </router-link>
                </template>
              </b-table>
            </div>
            <div class="row" v-if="rows > 10">
              <div class="col-2">
                <!-- <div v-if="selected[0]">
                        <b-button class="btn btn-sm" variant="danger" @click="bulkAction()">Bulk Delete : {{selected.length}} Rows Data</b-button>
                      </div> -->
                <label class="d-inline-flex align-items-center">
                  Page
                  <b-form-input
                    v-model="currentPage"
                    placeholder="Page"
                    class="form-control w-10 form-control ml-2"
                  ></b-form-input>
                </label>
              </div>
              <div class="col-10 text-right" v-if="rowsVerif > 10">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPageVerif"
                      :total-rows="rowsVerif"
                      :per-page="perPageVerif"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body" v-if="loading && !tableDataVerification[0]">
            <div class="row">
              <div class="col-12 text-center align-item-center m-5 p-5">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div>
                  <span>Loading..</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-reset-password"
      centered
      :title="$t('user-management.reset-password')"
      title-class="font-18"
      hide-footer
      @ok="resetPassword"
    >
      <!-- <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="validationCustom01">Email</label>
                <b-form-tags
                  input-id="tags-separators"
                  v-model="form.share.emails"
                  placeholder="Add email to share"
                  remove-on-delete
                  :class="{
                    'is-invalid': shared && form.share.emails.length == 0,
                  }"
                />
                <div
                  v-if="form.share.emails.length == 0"
                  class="invalid-feedback"
                >
                  <span v-if="form.share.emails.length == 0"
                    >This value is required.</span
                  >
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="validationCustom10">Message </label>
                <textarea
                  v-model="form.share.message"
                  class="form-control"
                  name="textarea"
                  rows="5"
                ></textarea>
              </div>
            </div>
          </div> -->

      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("user-management.new_password")
            }}</label>
            <div class="input-group">
              <input
                :type="show.new ? 'text' : 'password'"
                class="form-control"
                placeholder="*******"
                v-model="form.pass.new_password"
                :class="{
                  'is-invalid': submitted && $v.form.pass.new_password.$error,
                }"
              />
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <div v-if="show.new">
                    <i @click="show.new = false" class="fas fa-eye-slash"></i>
                  </div>
                  <div v-else>
                    <i @click="show.new = true" class="fas fa-eye"></i>
                  </div>
                </span>
              </div>
              <div
                v-if="submitted && $v.form.pass.new_password.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.pass.new_password.required">{{
                  $t("form.error.text")
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom02">{{
              $t("user-management.confirm_password")
            }}</label>
            <div class="input-group">
              <input
                :type="show.conf ? 'text' : 'password'"
                class="form-control"
                placeholder="*******"
                v-model="form.pass.confirm_password"
                :class="{
                  'is-invalid':
                    submitted && $v.form.pass.confirm_password.$error,
                }"
              />
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <div v-if="show.conf">
                    <i @click="show.conf = false" class="fas fa-eye-slash"></i>
                  </div>
                  <div v-else>
                    <i @click="show.conf = true" class="fas fa-eye"></i>
                  </div>
                </span>
              </div>
              <div
                v-if="submitted && $v.form.pass.confirm_password.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.pass.confirm_password.required">{{
                  $t("form.error.text")
                }}</span>
                <span
                  v-if="
                    !$v.form.pass.confirm_password.sameAsPassword &&
                    $v.form.pass.confirm_password.required
                  "
                  >{{ $t("form.error.match") }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="text-right">
            <b-button
              class="mt-3 mr-1"
              @click="$bvModal.hide('modal-reset-password')"
              variant="danger"
              >{{ $t("button.cancel") }}</b-button
            >
            <b-button
              class="mt-3 mr-1"
              @click="resetPassword()"
              variant="success"
              >{{ $t("button.update") }}</b-button
            >
          </div>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required, sameAs } from "vuelidate/lib/validators";
import UserService from "@/helpers/user.service";
import { userService } from "@/helpers/authservice/user.service";
import moment from "moment";
// import Stat from "@/components/widgets/stat";

export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    const statusReport = {
      chartOptions: {
        stroke: {
          colors: ["#e5e5e5"],
        },
        legend: {
          show: true,
          showForSingleSeries: false,
          showForNullSeries: true,
          showForZeroSeries: true,
          position: "bottom",
          horizontalAlign: "center",
          floating: false,
          fontSize: "14px",
          fontFamily: "Helvetica, Arial",
          fontWeight: 400,
          formatter: undefined,
          inverseOrder: false,
          width: undefined,
          height: undefined,
          tooltipHoverFormatter: undefined,
          customLegendItems: [],
          offsetX: 0,
          offsetY: 0,
          labels: {
            colors: "#fff",
            useSeriesColors: false,
          },
          markers: {
            width: 12,
            height: 12,
            strokeWidth: 0,
            strokeColor: "#fff",
            fillColors: undefined,
            radius: 12,
            customHTML: undefined,
            onClick: undefined,
            offsetX: 0,
            offsetY: 0,
          },
          itemMargin: {
            horizontal: 5,
            vertical: 4,
          },
          onItemClick: {
            toggleDataSeries: true,
          },
          onItemHover: {
            highlightDataSeries: true,
          },
        },
        chart: {
          type: "pie",
        },
        labels: ["draft", "pending", "not valid", "valid"],
        colors: ["#eab308", "#0ea5e9", "#f43f5e", "#059669"],

        plotOptions: {
          pie: {
            donut: {
              size: "60%",
            },
          },
        },
      },
    };
    return {
      id_user: "",
      theme: localStorage.getItem("theme"),
      rl: this.$store.state.authBackend.role,
      urlImage: process.env.VUE_APP_BASE_API_URL_AVATAR,
      form: {
        pass: {
          new_password: "",
          confirm_password: "",
        },
      },
      show: {
        new: false,
        conf: false,
      },
      submitted: false,

      status_report: {
        draft: 0,
        pending: 0,
        not_valid: 0,
        valid: 0,
      },
      total_report: 0,
      total_validation: 0,
      statusReport: statusReport,
      role: "",
      user_profile: {
        id_user: "",
        username: "",
        email: "",
        name: "",
        role: "",
        avatar: "",
        last_login: "",
        created_at: "",
        updated_at: "",
      },
      total_users: 0,
      total_admin: 0,
      total_analys: 0,
      total_verifikator: 0,
      loading: false,
      tableData: [],
      tableDataVerification: [],
      title: this.$t("user-management.user-management-detail"),
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: this.$t("user-management.user-management"),
          href: "/malware/user",
        },
        {
          text: this.$t("user-management.user-management-detail"),
          active: true,
        },
      ],
      statData: [
        {
          icon: "bx bx-user",
          title: "Total User",
          value: "11",
        },
        {
          icon: "bx bx-user",
          title: "Total User",
          value: "11",
        },
        {
          icon: "bx bx-user",
          title: "Total User",
          value: "11",
        },
        {
          icon: "bx bx-user",
          title: "Total User",
          value: "11",
        },
      ],

      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortDesc: false,

      totalRowsVerif: 1,
      currentPageVerif: 1,
      perPageVerif: 10,
      pageOptionsVerif: [10, 25, 50, 100],
      filterVerif: null,
      filterOnVerif: [],
      sortDescVerif: false,

      fields: [
        {
          key: "no",
          class: "text-center",
          thStyle: { width: "2%" },
          label: "No",
        },
        { key: "id_user", thClass: "d-none", tdClass: "d-none" },
        {
          key: "title",
          sortable: true,
          thStyle: { width: "25%" },
          label: this.$t("malware.title"),
        },
        {
          key: "description",
          thStyle: { width: "25%" },
          sortable: true,
          label: this.$t("malware.description"),
        },
        {
          key: "risk_score",
          sortable: true,
          label: this.$t("malware.risk-score"),
        },
        {
          key: "status_report",
          sortable: true,
          label: this.$t("malware.status-report"),
        },
        { key: "avatar", thClass: "d-none", tdClass: "d-none" },

        {
          key: "created_at",
          sortable: true,
          label: this.$t("table.created_at"),
        },
        {
          key: "actions",
          class: "text-center",
          label: this.$t("table.action"),
        },
      ],
      form: {
        user: {
          username: "",
          email: "",
          password: "",
          name: "",
          role: "",
        },
        pass: {
          new_password: "",
          confirm_password: "",
        },
      },
      show: {
        new: false,
        conf: false,
      },
      submitted: false,
    };
  },
  validations: {
    form: {
      user: {
        username: { required },
        email: { required },
        name: { required },
        password: { required },
        role: { required },
      },
      pass: {
        new_password: { required },
        confirm_password: { required, sameAsPassword: sameAs("new_password") },
      },
    },
  },

  computed: {
    rows() {
      return this.tableData.length;
    },
    rowsVerif() {
      return this.tableDataVerification.length;
    },
  },

  methods: {
    getUser() {
      let ferr = 0;
      UserService.detailUser(this.id_user)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getUser();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 1;
            let val = response.data.data;
            console.log("ud", response.data.data);
            this.user_profile.id_user = val.id_user;
            this.user_profile.username = val.username;
            this.user_profile.email = val.email;
            this.user_profile.name = val.name;
            this.user_profile.role = val.role ?? "-";
            this.user_profile.avatar = val.avatar ?? "";
            this.user_profile.last_login = val.last_login ?? "-";
            this.user_profile.created_at = this.formatDate(val.created_at);
            this.user_profile.updated_at = this.formatDate(val.updated_at);
            let rp = val.report;
            let vl = val.verification;
            this.total_report = rp.length;
            this.total_validation = vl.length;
            this.loading = false;
            ferr = 0;

            if (val.report[0]) {
              rp.forEach((el, idx) => {
                let report = {
                  no: idx + 1,
                  id_report: el.id_report,
                  title: el.title,
                  description: el.description,
                  risk_score: el.risk_score,
                  malware_logo: el.malware_logo ?? "cyber-attack.png",
                  status_report: el.status_report,
                  comments_count: el.comments_count,
                  created_at: moment(el.created_at).format("DD/MM/YYYY"),
                  malware_data: JSON.parse(el.malware_data),
                  tags: JSON.parse(el.tags),
                  report_by: el.report_by ?? null,
                  verify_by: el.verif_by ?? null,
                };

                if (el.status_report == 0) {
                  this.status_report.draft = this.status_report.draft + 1;
                } else if (el.status_report == 1) {
                  this.status_report.pending = this.status_report.pending + 1;
                } else if (el.status_report == 2) {
                  this.status_report.not_valid =
                    this.status_report.not_valid + 1;
                } else if (el.status_report == 3) {
                  this.status_report.valid = this.status_report.valid + 1;
                }
                this.tableData.push(report);
              });
            }

            let v = val.verification;
            if (val.verification[0]) {
              v.forEach((el, idx) => {
                let verif = {
                  no: idx + 1,
                  id_report: el.id_report,
                  title: el.title,
                  description: el.description,
                  risk_score: el.risk_score,
                  malware_logo: el.malware_logo ?? "cyber-attack.png",
                  status_report: el.status_report,
                  comments_count: el.comments_count,
                  created_at: moment(el.created_at).format("DD/MM/YYYY"),
                  malware_data: JSON.parse(el.malware_data),
                  tags: JSON.parse(el.tags),
                  report_by: el.report_by ?? null,
                  verify_by: el.verif_by ?? null,
                };

                this.tableDataVerification.push(verif);
              });
            }
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getUser();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading = false;
            }
          }
        });
    },

    setId() {
      const id = this.$route.query.id;
      if (id) {
        this.id_user = Buffer.from(id, "base64").toString("ascii");
      }
    },

    getId(id) {
      return Buffer.from(id).toString("base64");
    },

    resetPassword(e) {
      this.submitted = true;
      this.$v.form.pass.$touch();
      if (this.$v.form.pass.$invalid) {
        e.preventDefault();
      } else {
        console.log("new pass->", this.id_user, this.form.pass);
        UserService.resetPassword(this.id_user, this.form.pass)
          .then((response) => {
            if (response.status == 201) {
              let new_token = response.data.refresh_access_token;
              userService.splitToken(new_token);
              this.getUser();
              ferr = 1;
              this.$store.dispatch("notification/refreshtoken", "refresh");
            } else {
              Vue.swal({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
              this.$v.$reset();
              this.resetForm();
              this.closeChangePassword();
            }
          })
          .catch((err) => {
            if (err.response == undefined) {
              console.log("err ->> ", err);
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.getUser();
            } else {
              if (err.response.status == 401) {
                userService.logout();
              } else {
                console.log(err);
                this.$v.$reset();
                this.resetForm();
                this.closeChangePassword();
              }
            }
          });
      }
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    onFilteredVerif(filteredItems) {
      this.totalRowsVerif = filteredItems.length;
      this.currentPageVerif = 1;
    },

    openChangePassword() {
      console.log("open modal");
      this.$bvModal.show("modal-reset-password");
    },

    closeChangePassword() {
      console.log("open modal");
      this.$bvModal.hide("modal-reset-password");
    },

    onDelete(id) {
      console.log("delete data:", id);
    },

    onView(id) {
      console.log("details data:", id);
    },

    resetForm() {
      setTimeout(() => {
        this.form.pass.new_password = "";
        this.form.pass.confirm_password = "";
      }, 2000);
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD");
    },
  },
  created() {
    this.setId();
  },
  mounted() {
    this.totalRows = this.items.length;
    this.totalRowsVerif = this.items.length;
    this.getUser();
  },
};
</script>

<style scoped>
.badge {
  border-radius: 2%;
}
.btn {
  border-radius: 7%;
}
</style>
